<template>
  <div class="text-block big-card-block block-card card-border ">
    <v-expansion-panel
      :value="panel"
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text text-lg-2">date_range</v-icon>
            </div>

            <h4>
              Calender Booking
              <v-icon
                v-if = "errorsCount && errorsCount.errorsCount"
                color = "error"
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount" v-if="validData">
          <div class="block-card-body">

            <label for="">Button Label</label>
            <vTextareaAutocomplete
              v-model="data.buttonTitle"
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'Button label is Required']"
              :counter="20"
            />

            <label for="">Message</label>
            <vTextareaAutocomplete
              v-model="data.message"
              :type="'textarea'"
              :validation-rules=" [v => !!v || 'Message is Required']"
              :counter="1000"
            />

            <label for="">Extension Title</label>
            <vTextareaAutocomplete
                    v-model="data.extensionTitle"
                    :type="'textfield'"
                    :validation-rules=" [v => !!v || 'Title is Required']"
                    :counter="1000"
            />


            <label for="">Extension Message</label>
            <vTextareaAutocomplete
                    v-model="data.extensionMessage"
                    :type="'textarea'"
                    :validation-rules=" [v => !!v || 'Message is Required']"
                    :counter="1000"
            />


            <label>Save Date To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute_date"
              :error="!data.save_to_attribute_date"
              :error-messages="!data.save_to_attribute_date? 'Attribute is Required':'' "
              outline
            />

            <label>Save Time To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute_time"
              :error="!data.save_to_attribute_time"
              :error-messages="!data.save_to_attribute_time? 'Attribute is Required':'' "
              outline
            />



            <label for="">Error message</label>
            <vTextareaAutocomplete
              v-model="data.errorMessage"
              :type="'textarea'"
              :validation-rules=" [v => !!v || 'Error message is Required']"
              :counter="1000"
            />

            <label for="">Cancel button label</label>
            <vTextareaAutocomplete
                v-model="data.cancelButtonLabel"
                :type="'textfield'"
                :validation-rules=" [v => !!v || 'Cancel button label is Required']"
                :counter="1000"
            />

            <label for="">Cancel redirect block</label>
            <v-autocomplete
                :items="blocksList"
                v-model="data.cancelRedirectBlock"
                :error="!data.cancelRedirectBlock"
                :error-messages="!data.cancelRedirectBlock? 'Please select at least one block':'' "
                item-text="name"
                item-value="id"
                outline
                solo
                chips
            />


          </div>
          <json-header v-if="data.request" :headers="data.request.headers"/>
          <json-request :data-object="data.request"/>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
  import common from '../../../../utils/common'
  import FormValidation from '../FormValidation'
  import jsonHeader from './json-api/json-header'
  import jsonRequest from './json-api/request'
  export default {
    name: 'CardCalenderBooking',
    components: {
      FormValidation,
      jsonHeader,
      jsonRequest,
    },
    props: {
      data: {
        type: Object,
        default: () => {
          return {}
        }
      },
      index: {
        type: Number,
        default: () => {
          return 0
        }
      },
      blocksList: {
        type: Array,
        default: () => {
          return []
        }
      },
      validData: {
        type: Boolean,
        default: ()=> {
          return false
        }
      }
    },
    data() {
      return {
        errorsCount: { errorsCount: 0 },
        lazyRendering: true,
        valid: true,
        panel: 1,
        common,
        autocompleteImageUrlValidationrRules: [
          v => !!v || 'Image url is required'
        ]
      }
    },
    computed: {},
    watch: {
      errorsCount(val) {
        this.$emit('input', { errorsCount: val.errorsCount })
        this.data.errorsCount = val.errorsCount
      }
    },
    mounted() {
      if (this.data.errorsCount !== undefined) {
        this.errorsCount = this.data.errorsCount
      } else {
        // disabling Lazy rendering so we can grip errors count
        this.lazyRendering = false
        setTimeout(() => {
          // then we turn it on again to keep the performance up
          this.lazyRendering = true
        }, 1000)
      }
    },
    methods: {}
  }
</script>

<style scoped>
</style>
